<template>
  <div class="about">
    <b-container fluid class=" mt-2">
			
            <b-row class="mb-4" style="margin-top: 8%;">
                <b-col cols="12" md="12" class="px-4 d-block d-sm-block text-center">
                   
						  <div class="card mb-2" style="max-width: 40rem;margin-left: 25%;">
							
								<div class="card-body" >
									
									<!--<h3 class="card-title text-center">Thanks You</h3>-->
									  <p class="text-center promo-title" style="padding-top: 26px;">Thank You!</p>
									  
								</div>
							</div>
					
                </b-col> 
			</b-row>
			
		</b-container>
  </div>
</template>
<script>
export default {
	name: 'Logout',
	components: {
	},
	mounted(){
		this.logout();
	},
	data() {
		return{
			email: '',
			password: '',
			error_msg: '',
		};
	},
	methods: {
		logout(){
			//var userId = this.$root.customer_info.user_id;
			
			this.$session.destroy();
			this.$root.logout();
			//console.log('userId::'+userId);
			this.$router.push('/');
			//this.$router.push('/survey/'+btoa(userId));
			
		}
	}
}
</script>